import React from 'react';
import logo from './image.png';

const LogoIcon = () => {

  return (
    <div style={{width: '8em'}}>
      <img src={logo} alt="logo" style={{height: '6em', width: '100%', marginTop: '2em'}} />
      <div style={{fontWeight: 'bold', textAlign: 'center', color:'#FFFFFF'}}>Tech Compass</div>
    </div>
  );
};

export default LogoIcon;
